export default {
  orgSetting: '機構設置',
  chatbot: '聊天機器人',
  crm: '客戶管理',
  marketplace: '應用市場',
}